<template>
  <div id="home">
    <el-container v-if="isLogged">
      <el-aside width="220px">
        <menu-list></menu-list>
      </el-aside>
      <el-main id="main"><router-view></router-view></el-main>
    </el-container>
  </div>
</template>

<script>
import MenuList from './../02-organisms/MenuList.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'home',
  components: {
    'menu-list': MenuList
  },
  beforeRouteUpdate (to, from, next) {
    // console.log('beforeRouteUpdate:home')
    // console.log(to)
    // console.log(from)
    if (to.path === '/') {
      this.$router.replace('/books')
      next(false)
    } else {
      next()
    }
  },
  created: function () {
    // console.log('created:home')
    var self = this
    this.$store.dispatch('User/getEmail').then(function (response) {
      if (!response.result || !response.body.email) {
        self.$router.push('/login')
      } else if (self.$route.path === '/') {
        self.$router.replace('/books')
      }
    })
  },
  mounted () {
    this.resize()

    this.timer = 0

    var self = this
    window.addEventListener('resize', function (e) {
      e.preventDefault()

      if (self.timer > 0) {
        clearTimeout(self.timer)
      }

      self.timer = setTimeout(function () {
        self.resize()
      }, 100)
    })
  },
  updated () {
    console.log('updated:main')
    this.resize()
  },
  computed: {
    ...mapGetters('User', ['isLogged'])
  },
  methods: {
    resize () {
      if (document.getElementById('main')) {
        document.getElementById('main').style.height = this.contentHeight() + 'px'
      }
    }
  }
}
</script>

<style scoped>
#main{
  padding:0px 20px 20px 20px;
  border-left:solid 1px #e6e6e6;
}
</style>



// WEBPACK FOOTER //
// src/components/04-pages/Home.vue